import dayjs from 'dayjs'
import { t } from 'i18next'
import { useState } from 'react'
import { MainLoader, SearchSection, Card, SectionTitle } from 'src/components'
import { Grid } from 'src/layouts'
import { cardsDummyData } from 'src/lib'
import { useIsMobile } from 'src/utils'

const HomePage = () => {
  const isMobile = useIsMobile()
  const [state, setState] = useState()
  const firstSectionClasses = [
    'w-full',
    'h-screen',
    'bg-no-repeat',
    'bg-center',
    'bg-cover',
    'bg-home-photo2',
    'pt-[60px]',
    'flex-column',
    isMobile ? 'justify-start' : 'p-[30px] justify-end gap-[40px]',
  ]

  console.log(state, 'state')

  const filteredItems = state
    ? cardsDummyData.filter((item) => dayjs(item.date).isSame(state, 'day'))
    : cardsDummyData

  return (
    <MainLoader isLoading={false}>
      <div className='w-full min-f-fit'>
        <div className={firstSectionClasses.join(' ')}>
          {!isMobile && (
            <div className='w-full flex justify-between items-end gap-[50px]'>
              <div className='text-white w-1/2 text-[80px] text-bold text-left'>
                {t('home.discover.handpicked.journeys')}
              </div>
              <div className='text-white w-1/3 text-[20px] text-right'>
                {t('home.discover.handpicked.journeys.subtitle')}
              </div>
            </div>
          )}
          <SearchSection {...{ setState }} />
        </div>
        <div className='w-full flex-wrap bg-light-gray py-[40px] px-[30px]'>
          <SectionTitle
            title={t('global.need.some.trip.ideas')}
            subtitle={t('global.exclusive.offers')}
          />
          <Grid>
            {filteredItems.map((card, index) => (
              <Card
                key={index}
                delay={index * 1000}
                title={card.title}
                images={card.images}
                price={card.price}
                priceDescription={card.priceDescription}
                onClick={() => {}}
                label={card.label}
              />
            ))}
          </Grid>
        </div>
      </div>
    </MainLoader>
  )
}

export default HomePage
